import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  root: {
    fontWeight: 'bold',
    cursor: 'pointer',
  },
});
